import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';
import nosOptions from '../../../../data/districtNosOptions';

import './nos-selector.less';

function NOSSelector({ className, filters, onChange }) {
  return (
    <div className="nos-selector-container">
      <label className="nos-selector-label" htmlFor="nos-selector">
        Nature of Suit:{' '}
      </label>
      <div className={className}>
        <Select
          name="nos-field-name"
          options={nosOptions}
          multi
          simpleValue
          value={filters.get('nos')}
          placeholder="Select..."
          onChange={nos => onChange({ nos: nos || '' })}
        />
      </div>
    </div>
  );
}

NOSSelector.propTypes = {
  onChange: PropTypes.func,
  filters: PropTypes.any.isRequired,
  className: PropTypes.string,
};

NOSSelector.defaultProps = {
  onChange: () => {},
  className: '',
};

export default connect(state => mapValidationFieldsToClassName(state, 'nos', 'nos-selector'))(NOSSelector);



// WEBPACK FOOTER //
// ./src/components/search/FormElements/nosSelector/NOSSelector.js